import { render, staticRenderFns } from "./ProductOptionsItem.vue?vue&type=template&id=661189a8&"
import script from "./ProductOptionsItem.vue?vue&type=script&lang=js&"
export * from "./ProductOptionsItem.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ProductOptionsItem.vue?vue&type=style&index=0&lang=sass&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "b3ea23a4"
  
)

export default component.exports